fragment StagesetFragment on CustomFieldStagesetsConnection {
    isStagesetSpecific
    edges {
        isOnPipeline
        node {
            id
        }
    }
}
